import React from "react";

export default function DayNamesContainer({ dateHelper }) {
  return (
    <div className="day-names-container">
      {dateHelper.dayNames.map((dayName) => {
        return (
          <span key={dayName.short} className="day-name">
            {dayName.short}
          </span>
        );
      })}
    </div>
  );
}
